import { render, staticRenderFns } from "./ErrorsSummary.vue?vue&type=template&id=6d6f6006"
import script from "./ErrorsSummary.vue?vue&type=script&lang=ts"
export * from "./ErrorsSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports